import styled from 'styled-components';

import { spacing, body2, colors } from 'ui/theme';

import { JsonLeafProps } from '../types';

const Row = styled.div`
  display: grid;
  column-gap: ${spacing.base};
  grid-template-columns: 1fr 2fr;

  .json-property-value {
    color: ${colors.textPrimary};
  }
`;

const Cell = styled.div`
  ${body2}
  align-items: stretch;
  color: ${colors.textSecondary};
  display: flex;
  justify-content: start;
  padding: ${spacing.threeQuarter};
`;

export const Leaf = ({ label, startDecoration, value }: JsonLeafProps) => {
  return (
    <Row className="json-property json-row" data-test="json-leaf-table">
      <Cell className="json-property-key">
        {startDecoration}
        {label}
      </Cell>
      <Cell className="json-property-value">{value}</Cell>
    </Row>
  );
};
